import styled from 'styled-components';
import React, { FC } from 'react';

const ButtonGroupContainer = styled.div`
  display: flex;
  width: max-content;

  > button {
    border-radius: unset;
  }

  > button:first-of-type {
    border-top-left-radius: var(--radius-100);
    border-bottom-left-radius: var(--radius-100);
  }

  > button:last-of-type {
    border-top-right-radius: var(--radius-100);
    border-bottom-right-radius: var(--radius-100);
  }
`;

export const ButtonGroup: FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => {
  return <ButtonGroupContainer>{children}</ButtonGroupContainer>;
};
